
import { instantiate } from './looperkt-demos-noise-wasm-js.uninstantiated.mjs';
export default (await instantiate()).exports;
